import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DocumentTypes, DocumentTypeClient} from "src/app/web-api-client";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { DocumentTypeCreationComponent } from "./documentType-creation/documentType-creation.component";
import { DocumentTypeEditComponent } from "./documentType-edit/documentType-edit.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"; 


@Component({
  selector: 'app-documentType',
  templateUrl: './documentType.component.html',
  styleUrls: ['./documentType.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class DocumentTypeComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedObject: DocumentTypes;
  public allObjects: DocumentTypes[];

  // Assuming you already have a property for all the objects
  searchQuery: string = '';
  filteredObjects: DocumentTypes[] = [];




  constructor(private readonly changeDetectionRef:ChangeDetectorRef, private readonly modalService: NgbModal,public client:DocumentTypeClient){

  }

  ngOnInit(): void {

    this.loadData();

  }


  public filterObjects() {
    if (this.searchQuery) {
      this.filteredObjects = this.allObjects.filter(object =>
        object.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredObjects = this.allObjects;
    }
  }

  public loadData() {
        this.client.getList().subscribe((allObjects: DocumentTypes[]) => {
          this.allObjects = allObjects;
          this.filteredObjects = allObjects;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
    }

 public onSelected(object:DocumentTypes){
   if (this.isSelected(object)){
    this.selectedObject = null;
  }
  else{

     this.selectedObject = object;
  }
 }

  public isSelected(object:DocumentTypes):boolean{
    return this.selectedObject == object;
 }

public onCreation():void{
  let modalRef = this.modalService.open(DocumentTypeCreationComponent, {});

  modalRef.componentInstance.onClose.subscribe(r => {

    this.loadData();

  });

}


public onDelete(): void {


    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedObject.idDocumentType).subscribe(r => {
          this.modalService.open(SuccessModalComponent);
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(DocumentTypeEditComponent);
    modalRef.componentInstance.editObject = this.selectedObject;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();

    });

    }

}
